import Vue from 'vue'
import VueRouter from 'vue-router'
import Static from './static.js'

Vue.use(VueRouter)

const routes = [
  ...Static,
  {
    path: '/global',
    name: 'global',
    component: () => import('@/views/Report/Global.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/global',
    name: 'global-pdf',
    component: () => import('@/views/Report/GlobalPdf.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/local',
    name: 'local',
    component: () => import('@/views/Report/Local.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/local',
    name: 'local-pdf',
    component: () => import('@/views/Report/LocalPdf.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/lead-weekly',
    name: 'lead-weekly',
    component: () => import('@/views/Lpe/Report/LeadWeekly.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/internal',
    name: 'internal',
    component: () => import('@/views/Internal.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/external',
    name: 'external',
    component: () => import('@/views/External.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/userExpress',
    name: 'userExpress',
    component: () => import('@/views/UserExpress.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/lpe/lead-first',
    name: 'lpe-lead-first',
    component: () => import('@/views/Lpe/LeadFirst.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/lpe/dealer-first',
    name: 'lpe-dealer-first',
    component: () => import('@/views/Lpe/DealerFirst.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/lpe/customer',
    name: 'lpe-customer',
    component: () => import('@/views/Lpe/Customer.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/auto-reply/user/notification',
    name: 'autoreply-user-notification',
    component: () => import('@/views/Autoreply/User/Notification.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/profil-hub/import',
    name: 'profil-hub-import',
    component: () => import('@/views/Profilhub/Import.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
  {
    path: '/profil-hub/error',
    name: 'profil-hub-error',
    component: () => import('@/views/Profilhub/Error.vue'),
    props: route => ({
      email: route.params.email,
    }),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
